import Intercom from '@intercom/messenger-js-sdk';

export default function intercom() {
  Intercom({
    app_id: 'q67n063r',
  });
  // window.Intercom('boot', {
  //   app_id: 'q67n063r',
  //   hide_default_launcher: false,
  // });
  window.Intercom('onShow', function () {
    console.log('Intercom is shown');
    window.VWO = window.VWO || [];
    VWO.event =
      VWO.event ||
      function () {
        VWO.push(['event'].concat([].slice.call(arguments)));
      };
    VWO.event('intercomOnShow');
  });

  window.Intercom('onHide', function () {
    console.log('Intercom is hidden');
    window.VWO = window.VWO || [];
    VWO.event =
      VWO.event ||
      function () {
        VWO.push(['event'].concat([].slice.call(arguments)));
      };
    VWO.event('intercomOnHide');
  });
}
